import { IProjectView } from '../../types/builder';
import { IApplicationState } from '../../types/redux';
import { formatPriceRange, formatMaterials, formatFloors, formatArea } from '../../utils/formatters';

export const selectBuilderProjects = (state: IApplicationState): IProjectView[] => {
  return state.builderCard.projects.map(project => ({
    ...project,
    ...formatPriceRange(project.startPrice),
    area: formatArea(project.area),
    floors: formatFloors(project.floorCount, project.hasMansard),
    materials: formatMaterials(project.materials, project.otherMaterials),
  }));
};
